module.exports = __webpack_public_path__ + "static/media/femago_small_color_trim.85620582.svg";